import React from "react";
import axios from "axios";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import { UserContext } from "./components/auth/userContext";
import DevTools from "./components/autoFill/devTools/DevTools";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import MemberSignUp from "./components/auth/MemberSignUp";
import VerifyEmail from "./components/auth/VerifyEmail";
import Reset from "./components/auth/Reset";
import NavBar from "./components/layout/Navbar";
import Home from "./components/layout/Home";
import AutoFill from "./components/autoFill/AutoFill";
import PdfEditor from "./components/autoFill/PdfEditor";
import Profile from "./components/layout/Profile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// TODOs Temp klasörü içindeki route'ler değiştirilecek.
// import Member from "./components/Temp/Member";
// import OAuth from "./components/Temp/OAuth";
//import AutoFill from "./components/Temp/AutoFill";

import LegalSearch from "./components/Temp/LegalSearch";

axios.defaults.baseURL =
  "https://europe-west1-omnes-immigration-app.cloudfunctions.net/api";

function App() {
  const user = useSelector((state) => state.firebase.auth.currentUser);
  return (
    <>
      <BrowserRouter>
        <NavBar />
        <Switch>
          <UserContext.Provider value={{ user }}>
            <Route exact path="/signin" component={SignIn} />
            <Route exact path="/dev-tools" component={DevTools} />
            <Route exact path="/signup" component={SignUp} />
            <Route exact path="/verify-email" component={VerifyEmail} />
            <Route exact path="/reset" component={Reset} />
            <Route exact path="/member" component={MemberSignUp} />
            <Route exact path="/auto-fill" component={AutoFill} />
            <Route exact path="/pdf-editor" component={PdfEditor} />
            <Route exact path="/legal-search" component={LegalSearch} />
            <Route exact path="/profile" component={Profile} />
            <Route exact path="/" component={Home} />
          </UserContext.Provider>
        </Switch>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
